import { render } from "./Trash.vue?vue&type=template&id=6c82d3f4"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "6c82d3f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c82d3f4', script)) {
    api.reload('6c82d3f4', script)
  }
  
  module.hot.accept("./Trash.vue?vue&type=template&id=6c82d3f4", () => {
    api.rerender('6c82d3f4', render)
  })

}

script.__file = "src/icons/components/filled/Trash.vue"

export default script